module.exports = __webpack_public_path__ + "static/media/icon_alphabetical.a31867a6.svg";